import ClientRegistration from "./ClientRegistration";
export default class ClientRegistrationModel {
  constructor(
      public ClientId:  string,
      public ProviderId:  string ,
      public Name:  string,
      public Status:  string | null,
      public AllowedScopes:  [string] | null,
      public TokenLifetimeSeconds:  number | null,
      public MaxActiveTokens:  number | null,
      public CapPolicy:  string | null,
      public TokenFormat:  string | null,
      public AllowedClientAuth:  [string] | null,
      public AudienceAllowed:  [string] | null,
      public JwksUri:  string | null,
      public SecretString: string | null,
      public ErrorMessage: string | null,
  ) { }

  public static ClientRegistrationModel = (data: ClientRegistration) => {
    return new ClientRegistrationModel(
        data.ClientId,
        data.ProviderId,
        data.Name,
        data.Status,
        data.AllowedScopes  ,
        data.TokenLifetimeSeconds,
        data.MaxActiveTokens ,
        data.CapPolicy,
        data.TokenFormat,
        data.AllowedClientAuth,
        data.AudienceAllowed,
        data.JwksUri,
        data.SecretString,
        data.ErrorMessage
    )
  }
}
